import { render } from "./PageFooterMobile.vue?vue&type=template&id=4d7da600&scoped=true"
import script from "./PageFooterMobile.vue?vue&type=script&lang=js"
export * from "./PageFooterMobile.vue?vue&type=script&lang=js"

import "./PageFooterMobile.vue?vue&type=style&index=0&id=4d7da600&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7da600"]])

export default __exports__